import React, { useState, useEffect } from 'react';
import MapComponent from './MapComponent';
import DateSelector from './DateSelector';
import { fetchData } from './fetchData';

const App: React.FC = () => {
    const [dates, setDates] = useState<string[]>([]);
    const [selectedDate, setSelectedDate] = useState<string>(dates[0]);
    const [locations, setLocations] = useState<{ lat: number; lng: number, timestamp: string, bearing: number; }[]>([]);

    const handleLogout = () => {
        localStorage.removeItem('awsCredentials');
        localStorage.removeItem('idToken');
        window.location.reload();
    };

    useEffect(() => {
      const generateWeekdays = (startDate: string) => {
          const start = new Date(startDate);
          const end = new Date();
          // TODO: kind of a hack, should fix
          end.setDate(end.getDate() + 1);
          const dates: string[] = [];

          for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
              const day = d.getDay();
              if (day > 0 && day < 6) { // Exclude Sundays (0) and Saturdays (6)
                  const formattedDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                  dates.push(formattedDate);
              }
          }

          return dates;
      };

      const weekdays = generateWeekdays('2024-10-23');
      setDates(weekdays);
      setSelectedDate(weekdays[0]);
      }, []);

  useEffect(() => {
    const getData = async () => {
        if (selectedDate) {
            const data = await fetchData(selectedDate);
            // @ts-ignore
            setLocations(data);
        }
    };
    getData();
  }, [selectedDate]);

  return (
      <div>
          <div style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              zIndex: 1000
          }}>
              <button
                  onClick={handleLogout}
                  style={{
                      padding: '8px 16px',
                      backgroundColor: '#f44336',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                  }}
              >
                  Logout
              </button>
          </div>
          <DateSelector dates={dates} onSelectDate={setSelectedDate} />
          <MapComponent locations={locations} />
      </div>
  );
};
export default App;